import Filter from "./filter";
import FilterLogic from "./filterLogic";
import TableColumnDataType from "./tableColumnDataType";

const getFilterLogicDisplayName = (logic: string) => {
  if (logic === FilterLogic.Equal) {
    return "Equals";
  }
  if (logic === FilterLogic.NotEqual) {
    return "Not equals";
  }
  if (logic === FilterLogic.Greater) {
    return "Greater than";
  }
  if (logic === FilterLogic.Less) {
    return "Less than";
  }
  if (logic === FilterLogic.GreaterOrEqual) {
    return "Greater than or equal to";
  }
  if (logic === FilterLogic.LessOrEqual) {
    return "Less than or equal to";
  }
  if (logic === FilterLogic.Contains) {
    return "Contains";
  }
  if (logic === FilterLogic.StartsWith) {
    return "Starts with";
  }
  if (logic === FilterLogic.EndsWith) {
    return "Ends with";
  }

  return "";

  //     const logicDisplayMap: Record<string, string> = {
  //     equal: "Equals",
  //     notEqual: "Not equals",
  //     greater: "Greater than",
  //     less: "Less than",
  //     greaterOrEqual: "Greater than or equal to",
  //     lessOrEqual: "Less than or equal to",
  //     contains: "Contains",
  //     startsWith: "Starts with",
  //     endsWith: "Ends with",
  //   };

  //   const logicDisplay = logicDisplayMap[logic || ""] ?? logic ?? "";
  //   return logicDisplay;
};

const getFilterDisplayValue = (filter: Filter) => {
  if (filter.fieldType === TableColumnDataType.String) {
    return `"${filter.fieldDisplayValue}"`;
  }
  return filter.fieldDisplayValue;
};

const filtersToText = (filters: Filter[]) => {
  const filterStrings = filters.map(
    (f) =>
      `${f.fieldDisplayName} ${getFilterLogicDisplayName(
        f.fieldLogic,
      ).toLowerCase()} ${getFilterDisplayValue(f)}`,
  );
  const filterString = filterStrings.join(" and ");
  return filterString;
};

const isFiledValueInFilter = (fieldValue: any, filter: Filter) => {
  if (filter.fieldLogic === "" || filter.fieldLogic === FilterLogic.Equal) {
    if (fieldValue === filter.fieldValue) {
      return true;
    }
  } else if (filter.fieldLogic === FilterLogic.NotEqual) {
    if (fieldValue !== filter.fieldValue) {
      return true;
    }
  } else if (filter.fieldLogic === FilterLogic.Greater) {
    if (fieldValue > filter.fieldValue) {
      return true;
    }
  } else if (filter.fieldLogic === FilterLogic.Less) {
    if (fieldValue < filter.fieldValue) {
      return true;
    }
  } else if (filter.fieldLogic === FilterLogic.GreaterOrEqual) {
    if (fieldValue >= filter.fieldValue) {
      return true;
    }
  } else if (filter.fieldLogic === FilterLogic.LessOrEqual) {
    if (fieldValue <= filter.fieldValue) {
      return true;
    }
  } else if (filter.fieldLogic === FilterLogic.Contains) {
    if (
      (fieldValue as string)
        ?.toLowerCase()
        .includes(filter.fieldValue?.toLocaleLowerCase())
    ) {
      return true;
    }
  } else if (filter.fieldLogic === FilterLogic.StartsWith) {
    if (
      (fieldValue as string)
        ?.toLowerCase()
        .startsWith(filter.fieldValue?.toLocaleLowerCase())
    ) {
      return true;
    }
  } else if (filter.fieldLogic === FilterLogic.EndsWith) {
    if (
      (fieldValue as string)
        ?.toLowerCase()
        .endsWith(filter.fieldValue?.toLocaleLowerCase())
    ) {
      return true;
    }
  }

  return false;
};

const filterHelper = {
  filtersToText,
  isFiledValueInFilter,
};

export default filterHelper;
